import { Context } from "@nuxt/types/app";

const DEFAULT_ERROR_MESSAGE = "Terjadi kesalahan. Silakan coba lagi.";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function (context: Context) {
  /**
   * Shows error dialog for public pages (login, register, etc.)
   * User must click OK button to close the dialog
   * @param error - The error object from catch block
   */
  function showErrorDialog(error: unknown): void {
    let message = DEFAULT_ERROR_MESSAGE;

    if (error && typeof error === "object" && "message" in error) {
      const errorMessage = (error as { message?: string }).message || DEFAULT_ERROR_MESSAGE;
      console.error(errorMessage);
      message = errorMessage;
    }

    context.store.dispatch("app/toggleErrorDialog", {
      message,
    });
  }

  return {
    showErrorDialog,
  };
}

